import { render, staticRenderFns } from "./CreateJournal.vue?vue&type=template&id=85331bd6&"
import script from "./CreateJournal.vue?vue&type=script&lang=js&"
export * from "./CreateJournal.vue?vue&type=script&lang=js&"
import style0 from "./CreateJournal.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CreateJournal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports